var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuCalendario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1016.71 1024",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 422.21,
    y: 465.9,
    width: 169.85,
    height: 128.6,
    rx: 26.69,
    ry: 26.69
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M701.26,820.17h116.47c14.56,0,26.69-12.13,26.69-26.7v-75.22c0-14.56-12.13-26.69-26.69-26.69h-116.47c-14.56,0-26.69,12.13-26.69,26.69v75.22c-2.43,14.57,9.71,26.7,26.69,26.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M701.26,594.5h116.47c14.56,0,26.69-12.13,26.69-26.69v-75.22c0-14.56-12.13-26.69-26.69-26.69h-116.47c-14.56,0-26.69,12.13-26.69,26.69v75.22c-2.43,14.56,9.71,26.69,26.69,26.69Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.97,594.5h116.48c14.56,0,26.69-12.13,26.69-26.69v-75.22c0-14.56-12.13-26.69-26.69-26.69h-116.48c-14.56,0-26.69,12.13-26.69,26.69v75.22c-2.43,14.56,12.13,26.69,26.69,26.69Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M198.97,820.17h116.48c14.56,0,26.69-12.13,26.69-26.7v-75.22c0-14.56-12.13-26.69-26.69-26.69h-116.48c-14.56,0-26.69,12.13-26.69,26.69v75.22c-2.43,14.57,12.13,26.7,26.69,26.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M448.9,820.17h116.47c14.56,0,26.69-12.13,26.69-26.7v-75.22c0-14.56-12.13-26.69-26.69-26.69h-116.47c-14.56,0-26.69,12.13-26.69,26.69v75.22c0,14.57,12.13,26.7,26.69,26.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M922.08,99.5h-94.64v-43.69c0-29.12-24.26-55.81-55.81-55.81s-55.81,24.26-55.81,55.81v43.69h-417.36v-43.69c0-29.12-24.26-55.81-55.81-55.81s-55.81,24.26-55.81,55.81v43.69h-92.22C41.25,99.5,0,143.17,0,194.14v737.66c0,50.95,41.25,92.2,94.63,92.2h827.45c50.95,0,94.63-41.25,94.63-92.2V194.14c0-50.97-43.68-94.64-94.63-94.64ZM934.21,931.78c0,7.28-4.85,12.13-12.13,12.13H94.63c-7.28,0-12.13-4.85-12.13-12.13V347h851.71v584.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCalendario);
export default __webpack_public_path__ + "static/media/menu-calendario.99e6fe3da6a5228fce796e6dee69c30b.svg";
export { ForwardRef as ReactComponent };